import { STATUS } from '@const/healthStatus.constants';
import { Status } from '@dto/healthStatus.dto';
import { Tabs } from "antd";
import { useWebSocketReload } from 'src/hook/useWebSocketReload';
import { ThemeUtil } from 'src/util/ThemeUtil';
import CounterCircle from './CounterCircle';
import StateTab from './StateTable';
import useHealthCount from './hook/useHealthCount';

import type { JSX } from "react";

interface Tab {
  label: JSX.Element | string;
  key: Status;
  children: JSX.Element;
}

const StateTabs = () => {
  const data = useWebSocketReload('health-status');
  const state = useHealthCount([data]);
  const makeLabel = (key: string) => (key.charAt(0) + key.slice(1).toLowerCase());
  const tabs: Tab[] = [];
  const { UNDEFINED: _, TEST: __, ...statusesToOmit } = STATUS;
  let key: keyof typeof statusesToOmit;
  for (key in statusesToOmit) {
    tabs.push({
      label: key !== 'OK' && state[STATUS[key]] > 0 ?
        <CounterCircle counter={state[STATUS[key]]} xShift={97} yShift={-20} color={ThemeUtil.getHsColors()[STATUS[key]]}>
          {makeLabel(key)}
        </CounterCircle> : key === 'OK' ? key : makeLabel(key),
      key: STATUS[key],
      children: <StateTab wsData={data?.data} key={`${STATUS[key]}-tab`} type={STATUS[key]} url={`/api/global_status/v1/health/severity/${STATUS[key]}`} />,
    });
  }

  return <Tabs items={tabs} />;
};

export default StateTabs;
